import { useNavigate } from "react-router";
import { Dialog, DialogPage } from "../../../../components/modal/Dialog";
import { PRODUCT_LIST_CATEGORY } from "../../../../constants/routes";
import { useSupplierProduct } from "../../../../hooks/api/v2/product/useSupplierProduct";
import { ProductItemsPage } from "./pages/ProductItemsPage";
import { StatusPage } from "./pages/StatusPage";
import { ActiveProductCategoryDialogPages } from "./ActiveProductCategoryDialogTypes";

export { ActiveProductCategoryDialogPages } from "./ActiveProductCategoryDialogTypes";

export const ActiveProductCategoryDialog = ({
  active,
  onDismiss,
  productId,
  productActive,
}: {
  active: boolean;
  productId: number;
  onDismiss: () => void;
  productActive: boolean;
}) => {
  const navigate = useNavigate();

  const productQuery = useSupplierProduct(productId, { enabled: active });
  const childProducts = productQuery.data?.Products ?? [];

  const handleStatusConfirm = (selectedActive: boolean) => {
    navigate(
      `${PRODUCT_LIST_CATEGORY.href({ productId })}?tab=${selectedActive ? "Active" : "Inactive"}`,
    );
    onDismiss();
  };

  return (
    <Dialog
      active={active}
      onDismiss={onDismiss}
      initPage={ActiveProductCategoryDialogPages.STATUS}
    >
      <DialogPage page={ActiveProductCategoryDialogPages.STATUS}>
        {active && (
          <StatusPage
            productId={productId}
            productActive={productActive}
            onConfirm={(selectedActive) => handleStatusConfirm(selectedActive)}
            onDismiss={onDismiss}
          />
        )}
      </DialogPage>

      <DialogPage page={ActiveProductCategoryDialogPages.PRODUCT_ITEMS}>
        {active && (
          <ProductItemsPage
            products={childProducts}
            onComplete={() => handleStatusConfirm(true)}
          />
        )}
      </DialogPage>
    </Dialog>
  );
};
